/*
 * TunePad
 *
 * Michael S. Horn
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import { TunePadCell } from "./tunepad/cell";
import { TunePadProject } from "./tunepad/project";
import { TunePadProjectMenu } from "./tunepad/project-menu";
import { Timeline, TimelineScore, TimelineWaveform, TimelineMidi, TimelineCanvas } from "./tunepad/timeline";
import { BlockMenu, Block } from "./tunepad/blocks/blocks";
import { NoteMenu } from "./tunepad/blocks/note-menu";
import { ContextMenu, ContextMenuItem } from "./components";
import { LinearFader } from "./components/fader";
import { TunePadInstrument } from "./tunepad/instrument";
import { Piano as PianoInstrument } from "./instruments";
import { Marimba as MarimbaInstrument } from "./instruments";
import { DrumPad as DrumPadInstrument } from "./instruments";
import { CircleOfFifths, Passphrase } from "./components";
import { TunePadIcon } from "./icons/icon";
import { PythonEditor, PythonMessage } from './codemirror';
import { PythonOutput } from "./tunepad/output";
import { ProjectOutline } from "./tunepad/outline/outline";
import { TunePadAudio } from "./audio";
import { TunePadFile } from "./tunepad/file";
import { TunePadSample } from "./tunepad/sample";
import { QRCode } from "./components/qr-code";
import { showShareDialog } from "./tunepad/dialogs/share-dialog";

PythonEditor.DefineElement();
PythonMessage.DefineElement();
PythonOutput.DefineElement();

customElements.define(DrumPadInstrument.ELEMENT, DrumPadInstrument);
customElements.define(PianoInstrument.ELEMENT, PianoInstrument);
customElements.define(MarimbaInstrument.ELEMENT, MarimbaInstrument);
customElements.define(CircleOfFifths.ELEMENT, CircleOfFifths);

customElements.define(Timeline.ELEMENT, Timeline);
customElements.define(TimelineMidi.ELEMENT, TimelineMidi);
customElements.define(TimelineScore.ELEMENT, TimelineScore);
customElements.define(TimelineCanvas.ELEMENT, TimelineCanvas);
customElements.define(TimelineWaveform.ELEMENT, TimelineWaveform);

customElements.define(Block.ELEMENT, Block);
customElements.define(BlockMenu.ELEMENT, BlockMenu);
customElements.define(NoteMenu.ELEMENT, NoteMenu);

customElements.define(TunePadCell.ELEMENT, TunePadCell);
customElements.define(TunePadProject.ELEMENT, TunePadProject);
customElements.define(TunePadProjectMenu.ELEMENT, TunePadProjectMenu);
customElements.define(ProjectOutline.ELEMENT, ProjectOutline)
customElements.define(TunePadFile.ELEMENT, TunePadFile);
customElements.define(TunePadSample.ELEMENT, TunePadSample);
customElements.define(TunePadInstrument.ELEMENT, TunePadInstrument);
customElements.define(ContextMenu.ELEMENT, ContextMenu);
customElements.define(ContextMenuItem.ELEMENT, ContextMenuItem);
customElements.define(TunePadIcon.ELEMENT, TunePadIcon);

Passphrase.DefineElement();
QRCode.DefineElement();
LinearFader.DefineElement();


// Firefox bug fix. Audio context won't initialize correctly without a user event
document.addEventListener('pointerdown', e => {
    TunePadAudio.init();
    TunePadAudio._instance!.context = new AudioContext();
}, { once: true });

export { showShareDialog };
